/* CARSTN - Up All Night Radio
   Pulls the latest episode from the feeds worker (Podbean RSS) and updates the
   radio card in place. No worker URL set, or a failed fetch, leaves the
   manually entered episode untouched. */
(function () {
  var section = document.querySelector("#radioshow[data-worker-url]");
  if (!section) return;
  var worker = (section.getAttribute("data-worker-url") || "").trim().replace(/\/+$/, "");
  if (!worker) return;

  fetch(worker + "/latest-episode", { credentials: "omit" })
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (ep) {
      if (!ep || !ep.number) return;

      var epEl = section.querySelector(".radio__art .ep");
      if (epEl) epEl.textContent = ep.number;

      // show artwork (high-res channel cover) on the yellow card
      if (ep.cover) {
        var art = section.querySelector(".radio__art");
        if (art && !art.querySelector(".radio__art-cover")) {
          var c = document.createElement("img");
          c.className = "radio__art-cover";
          c.src = ep.cover;
          c.alt = "Up All Night Radio";
          c.loading = "lazy";
          art.appendChild(c);
        }
      }

      var titleEl = section.querySelector(".radio__now .title");
      var sub = ep.mix || (ep.title || "").replace(/^#\d+\s*·?\s*/, "");
      if (titleEl && sub) titleEl.textContent = sub;

      var metaEl = section.querySelector(".radio__now .meta");
      if (metaEl && ep.duration) {
        var cadence = (document.documentElement.lang || "").slice(0, 2).toLowerCase() === "en" ? "Bi-weekly" : "Zweiwöchentlich";
        metaEl.textContent = ep.duration + " · " + cadence;
      }

      var url = ep.episodeUrl || ep.mp3;
      if (url) {
        section.querySelectorAll("a.radio__art-play, .hero__cta a.btn--yellow").forEach(function (a) {
          a.setAttribute("href", url);
          a.setAttribute("target", "_blank");
          a.setAttribute("rel", "noopener");
        });
      }

      var btn = section.querySelector(".hero__cta a.btn--yellow");
      if (btn) btn.textContent = "▶ Listen to Ep. " + ep.number;

      // "Folgen live" stat -> latest episode number
      section.querySelectorAll(".radio__stat").forEach(function (s) {
        var lbl = s.querySelector("span");
        if (lbl && /folgen|episode/i.test(lbl.textContent)) {
          var num = s.querySelector("strong");
          if (num) num.textContent = ep.number;
        }
      });

      // cred-strip "Up All Night Radio episodes" quick-fact (separate section) -> live number
      document.querySelectorAll(".cred-strip__stat").forEach(function (s) {
        var lbl = s.querySelector("span");
        if (lbl && /up all night radio/i.test(lbl.textContent)) {
          var num = s.querySelector("strong");
          if (num) num.textContent = ep.number;
        }
      });

      // Marquee items flagged as the latest episode (originals + loop clones)
      document.querySelectorAll('[data-marquee="episode"]').forEach(function (el) {
        el.textContent = "Up All Night Radio, Ep. " + ep.number;
      });

      // hero "Up All Night Radio" meta value -> live episode number
      document.querySelectorAll("section.hero .hero__meta span").forEach(function (s) {
        var strong = s.querySelector("strong");
        if (strong && /up all night radio/i.test(strong.textContent)) {
          var n = strong.nextSibling;
          if (n && n.nodeType === 3) n.textContent = " Ep. " + ep.number;
          else s.appendChild(document.createTextNode(" Ep. " + ep.number));
        }
      });
    })
    .catch(function () { /* keep the manual episode */ });
})();
